import { Globe, Mail, MessageCircle } from "lucide-react";
import { useT } from "@/lib/i18n";
import siteConfig from "@/config/site.json";

export function OfficeMap() {
  const { tk } = useT();
  const email = siteConfig.contact.emails[0]?.address ?? "info@pulso33.com";

  return (
    <section className="border-t border-gold/15">
      <div className="max-w-5xl mx-auto px-6 py-20 text-center">
        <span className="text-xs tracking-[0.4em] uppercase text-gold">
          {tk("office.kicker", "How to reach us")}
        </span>
        <h2 className="font-serif text-3xl md:text-4xl mt-4">
          {tk("office.title.a", "Remote-first. ")}
          <em className="not-italic gold-gradient">
            {tk("office.title.b", "Worldwide.")}
          </em>
        </h2>
        <p className="mt-5 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          {tk(
            "office.intro",
            "PULSO33 is a distributed engineering team. We work with clients across Europe and the Americas — async-first, on your hours when it matters."
          )}
        </p>

        <div className="mt-10 grid sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
          <div className="rounded-2xl border border-gold/20 bg-card/30 p-6">
            <Globe size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              {tk("office.global", "Global")}
            </div>
            <div className="mt-1 text-sm text-foreground/85">
              {tk("office.global.line", "Europe · Americas")}
            </div>
          </div>
          <a
            href={`mailto:${email}`}
            className="rounded-2xl border border-gold/20 bg-card/30 p-6 hover:border-gold/60 transition-colors"
          >
            <Mail size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              Email
            </div>
            <div className="mt-1 text-sm text-foreground/85 break-all">{email}</div>
          </a>
          <a
            href={`https://wa.me/${siteConfig.contact.whatsapp.number.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-2xl border border-gold/20 bg-card/30 p-6 hover:border-gold/60 transition-colors"
          >
            <MessageCircle size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              WhatsApp
            </div>
            <div className="mt-1 text-sm text-foreground/85">
              {siteConfig.contact.whatsapp.number}
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
